// extracted by mini-css-extract-plugin
module.exports =  {"container":"Gyt9e5q","figure":"Lh72nB2","caption":"UkyP950"};